<template>
  <ButtonIconOnly :title="tr('common.CSV_EXPORT')"
                  :variant="BootstrapVariant.SECONDARY"
                  :size="size"
                  icon-name="download"
                  @click="$emit('click', $event)">
  </ButtonIconOnly>
</template>

<script>
  import ButtonIconOnly from '../../layout/ButtonIconOnly.vue';
  import BootstrapVariant from '~/zf/frontend/vendor/bootstrap/BootstrapVariant';
  import translator from '~/zf/frontend/common/mixins/translator';

  export default {
    name: 'CsvExportButton',
    compatConfig: {
      MODE: 3,
    },
    components: {
      ButtonIconOnly,
    },
    mixins: [translator],
    props: {
      size: {
        type: String,
        default: BootstrapVariant.MEDIUM,
      },
    },
    emits: ['click'],
    data() {
      return {
        BootstrapVariant,
      };
    },
  };
</script>
